var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RentalInfoShell',{attrs:{"isHistoric":true}}),_c('SingleButtonActionbar',{attrs:{"text":"View Chat"},on:{"click":function($event){_vm.$router.push('/inbox')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }